export default {
      id: "burger-usage",
      viewBox: "0 0 36 36",
      url: "assets/" + "sprite.svg#burger-usage",
      toString: function () {
        return this.url;
      }
    }